<div class="history">
  <div class="history-title">
    <div class="history-title-name">
      {{'CONTRACTS.CARD.HISTORY_TITLE'|translate}}
    </div>
    <div class="history-title-items-count">
      {{roadMapHistory?.length}}{{this.savedCountLabel}}
    </div>
  </div>
  <mat-list #shoes *ngIf="roadMapHistory" class="history-list" >
    @for (roadmap of roadMapHistory; track roadmap.guid) {
      <mat-list-item class="history-list-item" 
        (click)="selectRoadMap(roadmap)" data-action="selectedRoadMap"
        [class.selected-rm]="roadmap.guid === selectedRoadMap" >
        <div class="history-list-item-wrap">
          <div class="history-list-item-data">
            <div class="history-list-item-data-date">
              {{dateLabelsMap.get(roadmap.guid)}} {{$index===0? '(Текущая версия)':''}}
            </div>
            <div class="history-list-item-data-user">
              <app-contract-avatar class="history-list-item-data-user-avatar" 
              [userGuid]="roadmap.creator.guid" 
              [avatarSize]="'30px'">
            </app-contract-avatar>
            <div class="history-list-item-data-user-name">
              {{userNamesMap.get(roadmap.creator.guid)}}
            </div>
          </div>
          
        </div>
        <div *ngIf="roadmap.guid === selectedRoadMap" 
          class="action-icon contract-icon-confirm-circle history-list-item-icon"></div>
      </div>
      </mat-list-item>
    }
  </mat-list>
  <div class="history-buttons">
    <button class="button-icon size-l primary-button" data-action="restoreRoadMap" 
      [disabled]="!selectedRoadMap"
      (click)="restoreRoadMap()">
      <mat-icon svgIcon="arrow-go-back-fill"> </mat-icon>
      {{'CONTRACTS.CARD.RESTORE' | translate}}
    </button>
    <button class="button-icon size-l secondary-button" data-action="cancelAction" (click)="cancelAction()">
      <mat-icon svgIcon="close-fill"> </mat-icon>
      {{'CONTRACTS.CARD.CANCEL' | translate}}
    </button>
  </div>
</div>